var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.035,
    height: 27.441,
    viewBox: "0 0 23.035 27.441",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "add-document",
    d: "M17.424,17.628a1.1,1.1,0,0,1-1.1,1.1h-2.2v2.2a1.1,1.1,0,1,1-2.2,0v-2.2h-2.2a1.1,1.1,0,1,1,0-2.2h2.2v-2.2a1.1,1.1,0,1,1,2.2,0v2.2h2.2A1.1,1.1,0,0,1,17.424,17.628Zm6.61-6.076v9.381a5.515,5.515,0,0,1-5.509,5.509H7.509A5.515,5.515,0,0,1,2,20.933V5.509A5.515,5.515,0,0,1,7.509,0h4.974a7.666,7.666,0,0,1,5.454,2.259L21.775,6.1a7.658,7.658,0,0,1,2.26,5.452ZM16.379,3.816a5.52,5.52,0,0,0-1.158-.859V7.712a1.1,1.1,0,0,0,1.1,1.1h4.755a5.49,5.49,0,0,0-.86-1.157Zm5.452,7.735c0-.182-.035-.356-.052-.534H16.322a3.305,3.305,0,0,1-3.305-3.305V2.255c-.178-.017-.354-.052-.534-.052H7.509A3.305,3.305,0,0,0,4.2,5.509V20.933a3.305,3.305,0,0,0,3.305,3.305H18.526a3.305,3.305,0,0,0,3.305-3.305Z",
    transform: "translate(-1.5 0.5)",
    stroke: "#fff",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/fileUpload.89493e4483dd9c8ff1056d6999476789.svg";
export { ForwardRef as ReactComponent };